import {useEffect, useState} from 'react';
import {IconButton, InputAdornment, Stack, TextField, Tooltip} from '@mui/material';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import CheckIcon from '@mui/icons-material/Check';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {generatePassword} from '../utils/passwordGenerator';

export default function PasswordField({
    label,
    name,
    value = '',
    onChange,
    onGenerate,
    onBlur,
    register,
    error = false,
    helperText = '',
    required = false,
}) {
    const [visible, setVisible] = useState(false);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        setCopied(false);
    }, [value]);

    const registration = register || {};
    const handleChange = (event) => {
        registration.onChange?.(event);
        onChange?.(event.target.value);
    };
    const handleGenerate = () => {
        const generated = generatePassword();
        (onGenerate || onChange)?.(generated);
        setCopied(false);
    };
    const handleCopy = async () => {
        if (!value || !navigator.clipboard?.writeText) return;
        await navigator.clipboard.writeText(value);
        setCopied(true);
    };

    return (
        <TextField
            fullWidth
            required={required}
            name={name || registration.name}
            label={label}
            type={visible ? 'text' : 'password'}
            value={value}
            onChange={handleChange}
            onBlur={(event) => {
                registration.onBlur?.(event);
                onBlur?.(event);
            }}
            inputRef={registration.ref}
            error={error}
            helperText={helperText}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <Stack direction="row" spacing={0.25}>
                            <Tooltip title="Згенерувати пароль">
                                <IconButton type="button" aria-label="Згенерувати пароль" onClick={handleGenerate} edge="end">
                                    <AutorenewIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={visible ? 'Приховати пароль' : 'Показати пароль'}>
                                <IconButton
                                    type="button"
                                    aria-label={visible ? 'Приховати пароль' : 'Показати пароль'}
                                    onClick={() => setVisible((previous) => !previous)}
                                    edge="end"
                                >
                                    {visible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Копіювати пароль">
                                <IconButton
                                    type="button"
                                    aria-label="Копіювати пароль"
                                    onClick={handleCopy}
                                    disabled={!value}
                                    edge="end"
                                >
                                    {copied ? <CheckIcon color="success" /> : <ContentCopyOutlinedIcon />}
                                </IconButton>
                            </Tooltip>
                        </Stack>
                    </InputAdornment>
                ),
            }}
        />
    );
}